import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProformaIssueFormsDirectEmbedRoute: InvariantJiraRoute = {
	name: 'servicedesk-proforma-issue-forms-direct-embed',
	path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
	exact: true,
};
